// @flow
import React, { Component } from "react";
import Link from "gatsby-link";
import ArrowRight from "react-feather/dist/icons/arrow-right";
import CompanyLogo from "../../../shared/CompanyLogo/CompanyLogo";
import SeverityRating from "../../../shared/SeverityRating/SeverityRating";
import styles from "./BreachPopup.module.css";

type Props = {
  breach: PrismicBreach
};

type State = {};

class BreachPopup extends Component<Props, State> {
  render() {
    const {
      breach: { data, uid }
    } = this.props;
    return (
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <CompanyLogo
            companyName={data.company_name}
            companyUrl={data.company_url.url}
          />
        </div>
        <h4 className={styles.title}>{data.title.text}</h4>
        <div className={styles.footer}>
          <div className={styles.section}>
            <span className={styles.label}>Severity</span>
            <SeverityRating severity={data.severity} />
          </div>
          <div className={styles.linkWrapper}>
            <Link className={styles.link} to={uid}>
              View Breach <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default BreachPopup;



// WEBPACK FOOTER //
// ./src/components/Landing/Hero/BreachPopup/BreachPopup.js